export enum RecordOperations {
  None,
  Add,
  Delete,
  Update,
}
